import { useEffect } from 'react';

import { RestaurantsNamesReturnType } from '@restworld/data-services';

import { SpontaneousCandidateRestaurantFilterType } from '../employer-spontaneous-candidates.atoms';

function useSpontaneousCandidatesFiltersInUrl({
  restaurantNames,
  setRestaurantFilter,
  setShowHiddenFilter,
}: {
  setShowHiddenFilter: (value: boolean) => void;
  setRestaurantFilter: (value: SpontaneousCandidateRestaurantFilterType) => void;
  restaurantNames: RestaurantsNamesReturnType[];
}) {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hidden = urlParams.get('hidden');
    const restaurantId = urlParams.get('restaurant_id');
    setShowHiddenFilter(hidden === 'true');
    if (!restaurantId) return;
    const restaurantName = restaurantNames?.find((v) => v.id === restaurantId)?.restaurant_name;
    setRestaurantFilter({ id: restaurantId, restaurant_name: restaurantName });
  }, [restaurantNames, setRestaurantFilter, setShowHiddenFilter]);
}

export default useSpontaneousCandidatesFiltersInUrl;
